import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      display: "inline-block",
      cursor: "pointer",
      marginRight: 19,
      "&:last-child": {
        marginRight: 50,
      },
      [theme.breakpoints.up("tablet")]: {
        marginRight: 55,
        "&:last-child": {
          marginRight: 0,
        },
      },
    },
    personBg: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      width: 95.3,
      height: 95.3,
      margin: [15, 0],
      borderRadius: "100%",
      [theme.breakpoints.up("mobile")]: {
        width: 146,
        height: 146,
      },
    },
    calendarItem: {
      backgroundColor: ({ dateTypeTrimmed }) => theme.palette.calendarItemBackground[`${dateTypeTrimmed}`],
    },
    personHead: {
      width: 39.49,
      objectFit: "contain",
      [theme.breakpoints.up("mobile")]: {
        width: 63,
      },
    },
    personInfo: {
      display: "flex",
      flexDirection: "column",
    },
    personDateType: {
      marginTop: 8,
      [theme.breakpoints.up("mobile")]: {
        marginTop: 15,
        fontSize: theme.typography.large.fontSize,
      },
    },
    personDate: {
      marginTop: 5,
      [theme.breakpoints.up("mobile")]: {
        marginTop: 8,
        fontSize: theme.typography.regular.fontSize,
      },
    },
    cta: {
      position: "relative",
      "& .face-shape": {
        width: 39.49,
        [theme.breakpoints.up("mobile")]: {
          width: 63,
        },
      },
      "& .plus-shape": {
        position: "absolute",
        top: 43,
        width: 13,
        zIndex: 1,
        [theme.breakpoints.up("mobile")]: {
          top: 65,
          width: 20,
        },
      },
    },
  }),
  { name: "DisplayPerson" },
);
